import { render, staticRenderFns } from "./BookEditionView.vue?vue&type=template&id=675c4a9c"
import script from "./BookEditionView.vue?vue&type=script&lang=js"
export * from "./BookEditionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports